export const YOURCALL_EVENTS_STATUS = {
    BYB: {
        SUSP: 0,
        ACTIVE: 1,
        LIVE: 2,
    },
};
